const PropTypes = require('prop-types');
const React = require('react');

class CreditCardIcon extends React.Component {
  get cardIconClass() {
    return (
      `cc-${this.props.cardType.replace(/\s+/g, '-').toLowerCase()}`
    );
  }

  render() {
    if (!this.props.cardType) { return false; }

    return (
      <div className={this.cardIconClass}></div>
    );
  }
}

CreditCardIcon.propTypes = {
  cardType: PropTypes.string,
};

module.exports = CreditCardIcon;



// WEBPACK FOOTER //
// ./javascripts/components/credit_cards/credit_card_icon.jsx